import { getLanguageFromSupported, isLanguageSupported } from "./languageFromBrowser";

import { CustomDetector } from "i18next-browser-languagedetector";
import { getUrlParameter } from "@app/core/utilities/route";

export type CustomDetectorOptions = {
    fallbackLng: string;
    supportedLngs: string[];
};

export const languageDetectorPlugin: (customOptions: CustomDetectorOptions) => CustomDetector = customOptions => {
    return {
        name: "languageDetectorPlugin",

        lookup(options) {
            const lang = getUrlParameter(location.href, options.lookupQuerystring);

            let lookupLng = lang && getLanguageFromSupported(lang, customOptions.supportedLngs, null) ? lang : null;

            // If there is no query param, we look first into the localStorage, then the browser language
            if (!lookupLng) {
                const localStorageLng = localStorage.getItem(options.lookupLocalStorage);
                lookupLng = isLanguageSupported(localStorageLng, customOptions.supportedLngs)
                    ? localStorageLng
                    : getLanguageFromSupported(window.navigator.language, customOptions.supportedLngs, customOptions.fallbackLng);
            }

            return lookupLng;
        },
    };
};
